import { render, staticRenderFns } from "./DirectRecordTips.vue?vue&type=template&id=2636a15e&scoped=true"
import script from "./DirectRecordTips.vue?vue&type=script&lang=ts"
export * from "./DirectRecordTips.vue?vue&type=script&lang=ts"
import style0 from "./DirectRecordTips.vue?vue&type=style&index=0&id=2636a15e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2636a15e",
  null
  
)

export default component.exports